import {
  Container,
  ScoreWrapper,
  DescWrapper,
  TitleWrapper,
  Score,
} from './ScoreCardStackedStyles';
import QuestionIcon from '@/ui/icon/questionIcon/QuestionIcon';
import { COLORS } from '@/styles/colorTheme';
import { cn } from '@/lib/utils';

interface ScoreCardStackedProps {
  title?: string;
  score?: number;
  maxScore?: number;
  desc?: string;
  explanation?: string;
}

const ScoreCardStacked = ({
  title,
  score = 0,
  maxScore = 100,
  desc,
  explanation,
}: ScoreCardStackedProps) => {
  let color;
  let nofStacks = 0;
  if (desc === '매우 높음' || desc === 'Extremely High') {
    color = COLORS.Red200;
    nofStacks = 5;
  } else if (desc === '높음' || desc === 'High') {
    color = COLORS.Red200;
    nofStacks = 4;
  } else if (desc === '보통' || desc === 'Moderate') {
    color = COLORS.Secondary500;
    nofStacks = 3;
  } else if (desc === '낮음' || desc === 'Low') {
    color = COLORS.Blue200;
    nofStacks = 2;
  } else {
    color = COLORS.Blue200;
    nofStacks = 1;
  }
  const stackArr = new Array(5).fill(null);

  return (
    <Container>
      <TitleWrapper>
        <div className={cn(`text-text-400`)}>{title}</div>
        {explanation ? <QuestionIcon desc={explanation} /> : null}
      </TitleWrapper>

      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="33"
        height="32"
        viewBox="0 0 33 32"
        fill="none"
      >
        <g>
          {stackArr.map((stack, i) => (
            <rect
              key={i}
              x="0.199951"
              y={28 - 7 * i}
              width="32"
              height="4"
              rx="2"
              fill={i < nofStacks ? color : COLORS.Background100}
              fillOpacity="0.8"
            />
          ))}
        </g>
      </svg>

      <ScoreWrapper>
        <Score>
          <div className={cn(`text-text-400 text-xl flex items-center gap-0.5`)}>
            {score ? (
              <>
                {score}
                <div className={cn(`text-text-100 text-sm`)}>/ {maxScore}</div>
              </>
            ) : (
              <> </>
            )}
          </div>
        </Score>
      </ScoreWrapper>

      <DescWrapper>
        <div className={cn(`text-text-400 text-sm`)}>{desc ? <>{desc}</> : <></>}</div>
      </DescWrapper>
    </Container>
  );
};

export default ScoreCardStacked;
